import { splitAroundLink } from '../../../utils/unsupported-input';

interface TextWithLinkProps {
    text: string;
    /** The first occurrence of `link.text` in `text` becomes a plain link that opens in a new tab. */
    link?: { text: string; href: string } | null;
    className?: string;
    jkey?: string;
}

/**
 * FIX-6 copy with its one link (X6-2's "ruffle.rs"): `rel="noopener"`, new tab, the deck's own words as the
 * link text. Without a link, or when the text does not contain it, exactly `text`.
 */
export function TextWithLink({ text, link, className, jkey }: TextWithLinkProps) {
    const parts = splitAroundLink(text, link);
    if (!parts || !link) return <>{text}</>;
    return <>
        {parts[0]}
        <a href={link.href} target="_blank" rel="noopener" className={className} data-jkey={jkey}>{link.text}</a>
        {parts[1]}
    </>;
}
